import { Injectable } from '@angular/core';
import { SessionQuery } from '../../session/session.query';
import { AbsenceBackendService } from '../../../services/absence/absence-backend.service';
import { map, tap } from 'rxjs/operators';
import { AbsenceItemsStore } from './absence-items.store';
import { Observable } from 'rxjs';
import { AbsenceItemsQuery } from './absence-items.query';
import { AbsenceListItem } from 'src/app/core/models/client-models';

@Injectable({
  providedIn: 'root',
})
export class AbsenceItemsService {
  constructor(
    private sessionQuery: SessionQuery,
    private absenceService: AbsenceBackendService,
    private absenceItemsQuery: AbsenceItemsQuery,
    private absenceItemsStore: AbsenceItemsStore
  ) {}

  loadAbsences() {
    this.absenceItemsStore.setLoading(true);
    this.absenceService
      .getAbsences(0)
      .pipe(tap(() => this.absenceItemsStore.setLoading(false)))
      .subscribe({
        next: (data) => {
          this.absenceItemsStore.upsertMany(data);
          this.absenceItemsStore.setError(null);
        },
        error: (error) => this.absenceItemsStore.setError(error.error),
      });
  }

  clearCache() {
    this.absenceItemsStore.remove();
  }

  /**
   * Set active absence.
   *
   * @param id absence number.
   */
  setActive(id: number): void {
    this.absenceItemsStore.setActive(id);
  }

  /**
   * Create new observable stream with filtered value.
   *
   * @param value
   */
  filter(value: string): Observable<AbsenceListItem[]> {
    return this.absenceItemsQuery
      .selectAll()
      .pipe(
        map((absences) =>
          absences.filter(
            (absence) =>
              absence.absenceNr.toLowerCase().includes(value.toLowerCase()) ||
              absence.name.toLowerCase().includes(value.toLowerCase())
          )
        )
      );
  }

  filterAbsenceList(): void {
    const absences = this.absenceItemsQuery.getAll();
  }
}
